var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"color":"primary"}},[_c('v-row',{attrs:{"justify":"center","no-gutters":""}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v("translate-text")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }